import SelectedFileDisplay from './SelectedFileDisplay';

export default SelectedFileDisplay;
